import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  constructor(private router: Router) {}

  goToEnterpriseForm() {
    const currentUrl = this.router.url;
    this.router.navigate(['/enterprise/inquiry'], {
      queryParams: { source: currentUrl }
    });
  }
  
}
